/* eslint-disable react/jsx-curly-newline */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { PROCESS_STATUS } from '@plataforma/utils';
import EndorsementItem from '../EndorsementItem';

import * as S from './EndorsementsWrapperStyles';

function EndorsementsWrapper({
  endorsements,
  processNumber,
  onClickAnswerQuestion,
  onClickRequestEmission,
  onClickNewEndorsement,
  onClickDownloadPolicy,
  policyStatus
}) {
  const { t } = useTranslation();

  return (
    <>
      <S.Title>{t('policyDetail.endorsementTitle')}</S.Title>
      {endorsements && endorsements.length ? (
        <>
          <S.EndorsementList>
            {endorsements.map(endorsement => (
              <EndorsementItem
                {...endorsement}
                key={endorsement.documentNumber}
                onClickAnswerQuestion={() =>
                  onClickAnswerQuestion(endorsement.documentNumber)
                }
                onClickRequestEmission={() =>
                  onClickRequestEmission(endorsement.documentNumber)
                }
                onClickDownloadPolicy={() =>
                  onClickDownloadPolicy(endorsement.documentNumber)
                }
                policyStatus={policyStatus}
              />
            ))}
          </S.EndorsementList>
          {policyStatus.id !== PROCESS_STATUS.quoteCanceled.id && (
            <S.Button
              full
              data-testid="new-endorsement"
              size="big"
              variant="primary"
              onClick={() => onClickNewEndorsement(processNumber)}
            >
              {t('policyDetail.startEndorsementButton')}
            </S.Button>
          )}
        </>
      ) : (
        <>
          <S.NoEndorsementText>
            {t('policyDetail.noEndorsementText')}
          </S.NoEndorsementText>
          <S.Button
            size="small"
            variant="primary"
            onClick={onClickNewEndorsement}
          >
            {t('policyDetail.startEndorsementButton')}
          </S.Button>
        </>
      )}
    </>
  );
}

EndorsementsWrapper.propTypes = {
  processNumber: PropTypes.string,
  endorsements: PropTypes.arrayOf(PropTypes.object),
  onClickAnswerQuestion: PropTypes.func,
  onClickRequestEmission: PropTypes.func,
  onClickNewEndorsement: PropTypes.func,
  onClickDownloadPolicy: PropTypes.func,
  policyStatus: PropTypes.object
};

export default memo(EndorsementsWrapper);
